import isServer from '@framework/router/Next/isServer';

/* eslint-disable global-require */
if (!isServer()) {
  require('ts-replace-all'); // Chrome < 85, Firefox < 77

  require('@kuzorov/smoothscroll-polyfill'); // IE 11; Safari
  require('@kuzorov/webstorage-fallback'); // Old Safari; Chrome (incognito)
}

// Add location-change event for history (used for Google Analytics tracking)
if (!isServer()) {
  let { pushState } = window.history;
  let { replaceState } = window.history;

  window.history.pushState = (...args: Parameters<typeof pushState>) => {
    pushState.apply(window.history, args);
    window.dispatchEvent(new Event('pushstate'));
    window.dispatchEvent(new Event('locationchange'));
  };

  window.history.replaceState = (...args: Parameters<typeof replaceState>) => {
    replaceState.apply(window.history, args);
    window.dispatchEvent(new Event('replacestate'));
    window.dispatchEvent(new Event('locationchange'));
  };

  window.addEventListener('popstate', () => {
    window.dispatchEvent(new Event('locationchange'));
  });
}
